/**
 * Image Assets Configuration
 * Central location for all image imports and references
 * Organized by category: logo, background, and category images
 */

// Logo Images
import imdcLogo from './images/creative-works-logo.jpg';
import bisuLogo from './images/Bisu.webp';

// Background Images
import creativeBackground from './images/creative-background.png';


// Team Member Images
import jimby from './images/jimby.jpg';
import jhonel from './images/jhonel.jpg';
import omac from './images/Omac.jpg';
import emmanuelKent from './images/Emmanuel-Kent-P.-Paas.jpg';
import hecei from './images/Hecei-P.-Japitana.jpg';
import jhellJone from './images/Jhell-Jone-Labonite.jpg';
import junmar from './images/Junmar-Q.-Colinares.jpg';

// Category Images - Local
import balakImg from './images/creative-works-categories/Balak.png';
import childrenStoryImg from './images/creative-works-categories/Children-Story.png';
import editorialBoardImg from './images/creative-works-categories/Editorial-Board.png';
import fictionAdventureImg from './images/creative-works-categories/Fiction-Adventure.png';
import flashFictionImg from './images/creative-works-categories/Flash-Fiction.png';
import poetryImg from './images/creative-works-categories/Poetry.png';
import tulaImg from './images/creative-works-categories/Tula.png';

const categoryImages = {
  balak: balakImg,
  childrenStory: childrenStoryImg,
  editorialBoard: editorialBoardImg,
  fictionAdventure: fictionAdventureImg,
  flashFiction: flashFictionImg,
  poetry: poetryImg,
  tula: tulaImg,
};

export const imageAssets = {
  // Logo
  imdcLogo,
  bisuLogo,
  // Background
  creativeBackground,
  // Categories
  categories: categoryImages,
  // Team Members
  teamMembers: {
    jimby,
    jhonel,
    omac,
    emmanuelKent,
    hecei,
    jhellJone,
    junmar,
  },
};

// Export individual references for convenience
export default imageAssets;
